var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:[_vm.headerFont, 'grey--text font-weight-regular']},[_vm._v(_vm._s(_vm.header))]),_c('div',{class:_vm.css,staticStyle:{"line-height":"1.2"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }